/**
 * UI-тексты страницы жилья (AccommodationPageContent).
 * Вертикаль-специфичные строки: hero CTA, лейблы навигации, эйбрауы/заголовки секций,
 * подписи кнопок и тегов. Общие тексты сервис-страниц берутся из servicePage (sp.*).
 * Интерполируемые строки — функции; выбор уже локализованного значения остаётся в компоненте.
 */
export const stayPage = {
    en: {
        // Хлебная крошка (leaf) и навигация (anchors)
        leaf: 'Stay',
        anchor: { services: 'Services', cities: 'Cities', types: 'Types' },

        // Hero CTA (интерполяция названием города)
        heroBook: (city) => `Book a hotel in ${city}`,
        heroCities: 'Choose a city',

        // Эйбрауы секций (вертикаль-специфичные — нет в servicePage)
        eyebrow: {
            services: 'Services',
            cities: 'Cities',
            types: 'Accommodation types',
            picks: 'Picks',
        },

        // Заголовки секций (fallback к content.*)
        servicesTitle: 'Where to book',
        citiesTitle: 'Where to stay',
        typesTitle: 'Where to stay',
        picksTitle: 'Our picks',

        // Подписи кнопок / ссылок / тегов
        bestHotels: 'Best hotels',
        view: 'View',
        stayTag: 'Stay',
        findHotelsNearby: 'Find hotels nearby',

        // Кнопка «показать ещё / свернуть» (n — число скрытых)
        showLess: 'Show less',
        showMore: (n) => `Show more (${n})`,
    },
    ru: {
        leaf: 'Жильё',
        anchor: { services: 'Сервисы', cities: 'Города', types: 'Типы' },

        heroBook: (city) => `Забронировать отель в ${city}`,
        heroCities: 'Выбрать город',

        eyebrow: {
            services: 'Сервисы',
            cities: 'Города',
            types: 'Типы размещения',
            picks: 'Подборки',
        },

        servicesTitle: 'Где бронировать',
        citiesTitle: 'Где остановиться',
        typesTitle: 'Где остановиться',
        picksTitle: 'Рекомендуем',

        bestHotels: 'Лучшие отели',
        view: 'Смотреть',
        stayTag: 'Жильё',
        findHotelsNearby: 'Найти отели рядом',

        showLess: 'Свернуть',
        showMore: (n) => `Показать ещё (${n})`,
    },
};
